<template>
  <el-dialog
          :title="'附件查看'"
          :close-on-click-modal="false"
          :visible.sync="visible"
  style="text-align: left">
    <el-image v-if="!imgList || imgList.length===0" style="width: 100%; height: 150px">
      <div slot="error" class="image-slot">
        <span>暂无图片</span>
      </div>
    </el-image>
    <el-carousel v-else>
      <el-carousel-item v-for="item in imgList" :key="item" >
        <el-image  style="width: 100%; height: 360px"   :src="item" :preview-src-list="imgList" :z-index="9999" ></el-image>
      </el-carousel-item>
    </el-carousel>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {

    data () {
      return {
        visible: false,
        imgList:[]

      }
    },
    methods: {
      init (id,type) {
        this.visible = true
        this.fileList = []
        this.$nextTick(() => {
          console.log('11111111111111111111')
          if ( id && (type||type===0) ) {
            let path = ''
            if (type === 0) path = 'jiangcheng'
            else if (type === 1) path = 'credentialsUser'
            else if (type === 2) path = 'workContract'
            this.$http({
              url: `/bjba/${path}/findImgList/${id}`,
              method: 'get',
            }).then(({data}) => {
              this.imgList = data.data
            })
          }
        })

      },
    }
  }
</script>
